import {
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import useVehicleList from "./useVehicleList";
import EmptyData from "../../../Global/EmptyData";
import OrderColumn from "../../../Global/OrderColumn";

const VehicleList = () => {
  const {
    isLoading,
    isFetching,
    vehicleList,
    showEditModal,
    vehicleListState,
    paginationOptions,
    updateVehicleListingFields,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useVehicleList();
  return (
    <>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={vehicleListState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: vehicleListState?.search }}
          showActions={true}
          handleActionClick={handleEditColumnsClick}
        />
        {vehicleList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={vehicleList?.data?.result || []}
            uniqueID={"id"}
            fields={vehicleList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={vehicleListState?.clearSelection}
            perpage={vehicleListState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={vehicleList?.data?.fields || []}
              moduleId={vehicleList?.data?.module_id}
              updateData={updateVehicleListingFields}
            />
          </div>
        </ModalLayout>

        {vehicleList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={vehicleListState?.currentPage}
            totalPageCount={Math.ceil(
              vehicleList.data.total_count / vehicleListState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === vehicleListState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
      </div>
    </>
  );
};

export default VehicleList;
